/* eslint-disable */
// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies,long_type_string,optimize_speed,eslint_disable,ts_nocheck
// @generated from protobuf file "manager/core/proto/merge-tags.proto" (package "manager.core.mergetags", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UUID } from "../../../pkg/proto/type";
import { Info } from "../../../pkg/proto/response";
/**
 * @generated from protobuf message manager.core.mergetags.GetUnitMergeTagsRequest
 */
export interface GetUnitMergeTagsRequest {
    /**
     * Where the tags are used. PROJECT for a project overview; TASK_REGULAR,
     * TASK_EVENT or TASK_PARTICIPANT for a task description of that task type,
     * which adds the assignee tags. UNKNOWN is rejected.
     *
     * @generated from protobuf field: manager.core.mergetags.MergeTagContext merge_tag_context = 1;
     */
    mergeTagContext: MergeTagContext;
    /**
     * Public ID of the project (PROJECT context) or task (task contexts), as the
     * Legacy app knows it. Send it to get values; leave it empty to get only the
     * available tags, without values. In a task context, a task the Legacy app
     * does not know fails the call.
     *
     * @generated from protobuf field: optional string unit_id = 3;
     */
    unitId?: string;
}
/**
 * @generated from protobuf message manager.core.mergetags.GetUnitMergeTagsResponse
 */
export interface GetUnitMergeTagsResponse {
    /**
     * Message for display. `status` is ERROR, with no tags, when
     * `merge_tag_context` is UNKNOWN.
     *
     * @generated from protobuf field: response.Info info = 1;
     */
    info?: Info;
    /**
     * Built-in tags first, then custom field tags. Custom fields marked internal
     * only are never included.
     *
     * @generated from protobuf field: repeated manager.core.mergetags.MergeTag merge_tags = 2;
     */
    mergeTags: MergeTag[];
}
/**
 * @generated from protobuf message manager.core.mergetags.MergeTag
 */
export interface MergeTag {
    /**
     * ID of the custom field behind the tag. Empty for built-in tags such as
     * CUSTOMER_NAME.
     *
     * @generated from protobuf field: type.UUID id = 1;
     */
    id?: UUID;
    /**
     * Text written between braces in the template, e.g. `CUSTOMER_NAME` for
     * `{CUSTOMER_NAME}`. For a custom field it is the label in upper case with
     * spaces as underscores, plus `_2`, `_3` and so on when taken.
     *
     * @generated from protobuf field: string slug = 2;
     */
    slug: string;
    /**
     * Name to show in the tag picker, e.g. `Customer Company Name`, or the
     * custom field label.
     *
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * Value of the tag for `unit_id`. Empty when no `unit_id` was sent or the
     * project or task has no value for it.
     *
     * @generated from protobuf field: optional string value = 4;
     */
    value?: string;
}
/**
 * @generated from protobuf message manager.core.mergetags.HydrateMergeTagsRequest
 */
export interface HydrateMergeTagsRequest {
    /**
     * Where the text is used. PROJECT for a project overview; TASK_REGULAR,
     * TASK_EVENT or TASK_PARTICIPANT for a task description. UNKNOWN is an
     * InvalidArgument error.
     *
     * @generated from protobuf field: manager.core.mergetags.MergeTagContext merge_tag_context = 1;
     */
    mergeTagContext: MergeTagContext;
    /**
     * Public ID of the project (PROJECT context) or task (task contexts), as the
     * Legacy app knows it. Required: empty is an InvalidArgument error. In a
     * task context, a task the Legacy app does not know fails the call.
     *
     * @generated from protobuf field: string unit_id = 3;
     */
    unitId: string;
    /**
     * Text with tags written as `{SLUG}`, e.g. `Hello {CUSTOMER_NAME}`.
     *
     * @generated from protobuf field: string template_text = 4;
     */
    templateText: string;
}
/**
 * @generated from protobuf message manager.core.mergetags.HydrateMergeTagsResponse
 */
export interface HydrateMergeTagsResponse {
    /**
     * Message for display.
     *
     * @generated from protobuf field: response.Info info = 1;
     */
    info?: Info;
    /**
     * `template_text` with each tag replaced by its value. Tags with no value,
     * and unknown tags, are left as written. A `$` followed by a name or number
     * in a value is dropped with that name or number.
     *
     * @generated from protobuf field: string hydrated_text = 2;
     */
    hydratedText: string;
}
/**
 * @generated from protobuf enum manager.core.mergetags.MergeTagContext
 */
export enum MergeTagContext {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: PROJECT = 1;
     */
    PROJECT = 1,
    /**
     * @generated from protobuf enum value: TASK_REGULAR = 2;
     */
    TASK_REGULAR = 2,
    /**
     * @generated from protobuf enum value: TASK_EVENT = 3;
     */
    TASK_EVENT = 3,
    /**
     * @generated from protobuf enum value: TASK_PARTICIPANT = 4;
     */
    TASK_PARTICIPANT = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class GetUnitMergeTagsRequest$Type extends MessageType<GetUnitMergeTagsRequest> {
    constructor() {
        super("manager.core.mergetags.GetUnitMergeTagsRequest", [
            { no: 1, name: "merge_tag_context", kind: "enum", T: () => ["manager.core.mergetags.MergeTagContext", MergeTagContext] },
            { no: 3, name: "unit_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetUnitMergeTagsRequest>): GetUnitMergeTagsRequest {
        const message = { mergeTagContext: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetUnitMergeTagsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUnitMergeTagsRequest): GetUnitMergeTagsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* manager.core.mergetags.MergeTagContext merge_tag_context */ 1:
                    message.mergeTagContext = reader.int32();
                    break;
                case /* optional string unit_id */ 3:
                    message.unitId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUnitMergeTagsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* manager.core.mergetags.MergeTagContext merge_tag_context = 1; */
        if (message.mergeTagContext !== 0)
            writer.tag(1, WireType.Varint).int32(message.mergeTagContext);
        /* optional string unit_id = 3; */
        if (message.unitId !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.unitId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message manager.core.mergetags.GetUnitMergeTagsRequest
 */
export const GetUnitMergeTagsRequest = new GetUnitMergeTagsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUnitMergeTagsResponse$Type extends MessageType<GetUnitMergeTagsResponse> {
    constructor() {
        super("manager.core.mergetags.GetUnitMergeTagsResponse", [
            { no: 1, name: "info", kind: "message", T: () => Info },
            { no: 2, name: "merge_tags", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => MergeTag }
        ]);
    }
    create(value?: PartialMessage<GetUnitMergeTagsResponse>): GetUnitMergeTagsResponse {
        const message = { mergeTags: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetUnitMergeTagsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUnitMergeTagsResponse): GetUnitMergeTagsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* response.Info info */ 1:
                    message.info = Info.internalBinaryRead(reader, reader.uint32(), options, message.info);
                    break;
                case /* repeated manager.core.mergetags.MergeTag merge_tags */ 2:
                    message.mergeTags.push(MergeTag.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUnitMergeTagsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* response.Info info = 1; */
        if (message.info)
            Info.internalBinaryWrite(message.info, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated manager.core.mergetags.MergeTag merge_tags = 2; */
        for (let i = 0; i < message.mergeTags.length; i++)
            MergeTag.internalBinaryWrite(message.mergeTags[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message manager.core.mergetags.GetUnitMergeTagsResponse
 */
export const GetUnitMergeTagsResponse = new GetUnitMergeTagsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeTag$Type extends MessageType<MergeTag> {
    constructor() {
        super("manager.core.mergetags.MergeTag", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "value", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<MergeTag>): MergeTag {
        const message = { slug: "", name: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<MergeTag>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MergeTag): MergeTag {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* type.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string slug */ 2:
                    message.slug = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* optional string value */ 4:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MergeTag, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* type.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string slug = 2; */
        if (message.slug !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.slug);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* optional string value = 4; */
        if (message.value !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message manager.core.mergetags.MergeTag
 */
export const MergeTag = new MergeTag$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HydrateMergeTagsRequest$Type extends MessageType<HydrateMergeTagsRequest> {
    constructor() {
        super("manager.core.mergetags.HydrateMergeTagsRequest", [
            { no: 1, name: "merge_tag_context", kind: "enum", T: () => ["manager.core.mergetags.MergeTagContext", MergeTagContext] },
            { no: 3, name: "unit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "template_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<HydrateMergeTagsRequest>): HydrateMergeTagsRequest {
        const message = { mergeTagContext: 0, unitId: "", templateText: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<HydrateMergeTagsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HydrateMergeTagsRequest): HydrateMergeTagsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* manager.core.mergetags.MergeTagContext merge_tag_context */ 1:
                    message.mergeTagContext = reader.int32();
                    break;
                case /* string unit_id */ 3:
                    message.unitId = reader.string();
                    break;
                case /* string template_text */ 4:
                    message.templateText = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HydrateMergeTagsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* manager.core.mergetags.MergeTagContext merge_tag_context = 1; */
        if (message.mergeTagContext !== 0)
            writer.tag(1, WireType.Varint).int32(message.mergeTagContext);
        /* string unit_id = 3; */
        if (message.unitId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.unitId);
        /* string template_text = 4; */
        if (message.templateText !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.templateText);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message manager.core.mergetags.HydrateMergeTagsRequest
 */
export const HydrateMergeTagsRequest = new HydrateMergeTagsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HydrateMergeTagsResponse$Type extends MessageType<HydrateMergeTagsResponse> {
    constructor() {
        super("manager.core.mergetags.HydrateMergeTagsResponse", [
            { no: 1, name: "info", kind: "message", T: () => Info },
            { no: 2, name: "hydrated_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<HydrateMergeTagsResponse>): HydrateMergeTagsResponse {
        const message = { hydratedText: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<HydrateMergeTagsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HydrateMergeTagsResponse): HydrateMergeTagsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* response.Info info */ 1:
                    message.info = Info.internalBinaryRead(reader, reader.uint32(), options, message.info);
                    break;
                case /* string hydrated_text */ 2:
                    message.hydratedText = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HydrateMergeTagsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* response.Info info = 1; */
        if (message.info)
            Info.internalBinaryWrite(message.info, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string hydrated_text = 2; */
        if (message.hydratedText !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.hydratedText);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message manager.core.mergetags.HydrateMergeTagsResponse
 */
export const HydrateMergeTagsResponse = new HydrateMergeTagsResponse$Type();
/**
 * @generated ServiceType for protobuf service manager.core.mergetags.MergeTagService
 */
export const MergeTagService = new ServiceType("manager.core.mergetags.MergeTagService", [
    { name: "GetUnitMergeTags", options: {}, I: GetUnitMergeTagsRequest, O: GetUnitMergeTagsResponse },
    { name: "HydrateMergeTags", options: {}, I: HydrateMergeTagsRequest, O: HydrateMergeTagsResponse }
]);
